var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTooltip)?_c('span',[_c('div',{staticClass:"delivery-time-tooltip-container"},[_c('div',{staticClass:"delivery-time-tooltip"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_vm._t("default")],2)]):_c('span',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }